import React from 'react';
import { Box, Container, Typography, Card } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function AboutUs() {
  return (
    <Box sx={{ bgcolor: '#131722', minHeight: '100vh', py: 6 }}>
      <Container maxWidth="md">
        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h2" sx={{ fontWeight: 700, color: '#fff', mb: 2 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ color: '#d1d4dc', fontSize: '1.1rem', mb: 1 }}>
            We're here to assist you with any inquiries regarding your evaluation, registration, or support.
          </Typography>
          <Typography variant="body2" sx={{ color: '#888', fontStyle: 'italic', mt: 2 }}>
            Please note that all queries are handled exclusively through email for verification and security purposes. Our response time is typically within 24 hours on business days.
          </Typography>
        </Box>

        {/* Contact Cards */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Email Support Card */}
          <Card
            sx={{
              bgcolor: '#1e222d',
              border: '1px solid #2a2e39',
              borderRadius: 3,
              p: 4,
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 24px rgba(59, 130, 246, 0.2)',
                borderColor: '#3b82f6'
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(59, 130, 246, 0.4))',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2,
                  border: '2px solid rgba(59, 130, 246, 0.6)'
                }}
              >
                <EmailIcon sx={{ color: '#3b82f6', fontSize: 32 }} />
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#fff' }}>
                Email Support
              </Typography>
            </Box>

            <Box sx={{ pl: 2 }}>
              <Typography
                variant="h5"
                sx={{
                  color: '#3b82f6',
                  fontWeight: 600,
                  mb: 2,
                  fontSize: '1.5rem',
                  letterSpacing: 0.5
                }}
              >
                support@xfundingsplatform.com
              </Typography>
              <Typography sx={{ color: '#d1d4dc', lineHeight: 1.7 }}>
                For all queries related to registration, account verification, reward request, and compliance.
              </Typography>
            </Box>
          </Card>

          {/* Info Cards Grid */}
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
            {/* Response Time Card */}
            <Card
              sx={{
                bgcolor: '#1e222d',
                border: '1px solid #2a2e39',
                borderRadius: 3,
                p: 3,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 24px rgba(16, 185, 129, 0.2)',
                  borderColor: '#10b981'
                }
              }}
            >
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2), rgba(16, 185, 129, 0.4))',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                  border: '2px solid rgba(16, 185, 129, 0.6)'
                }}
              >
                <AccessTimeIcon sx={{ color: '#10b981', fontSize: 28 }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#fff', mb: 1 }}>
                Response Time
              </Typography>
              <Typography sx={{ color: '#d1d4dc', fontSize: '0.95rem' }}>
                Within 24 hours on business days
              </Typography>
            </Card>

            {/* Support Type Card */}
            <Card
              sx={{
                bgcolor: '#1e222d',
                border: '1px solid #2a2e39',
                borderRadius: 3,
                p: 3,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 24px rgba(139, 92, 246, 0.2)',
                  borderColor: '#8b5cf6'
                }
              }}
            >
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(139, 92, 246, 0.4))',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                  border: '2px solid rgba(139, 92, 246, 0.6)'
                }}
              >
                <SupportAgentIcon sx={{ color: '#8b5cf6', fontSize: 28 }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#fff', mb: 1 }}>
                Email Only
              </Typography>
              <Typography sx={{ color: '#d1d4dc', fontSize: '0.95rem' }}>
                For verification and security purposes
              </Typography>
            </Card>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default AboutUs;
